import FilesGrid from './FilesGrid'

export default FilesGrid
